import{z}from"zod";import{passwordValidator}from"../../../lib/validator/password";export var CreatePasswordFormSchema=z.object({password:passwordValidator});